import axios from "axios";

const dashboard = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getData(context, payload) {
            let response = await axios.get(`/dashboard_sale_order/${payload.startDate}/${payload.endDate}/${payload.enStartDate}/${payload.enEndDate}${payload.userid === '' ? '' : `/${payload.userid}`}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCallList(context, payload) {
            let response = await axios.get(`/get_call_list/${payload.Number}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsersList() {
            let response = await axios.get(`/get_users_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getYearlyData(context, payload) {
            let response = await axios.post(`/get_sale_report_yearly`, {
                selectedCompany: payload.selectedCompany,
                selectedUsers: payload.selectedUsers,
                selectedYear: payload.selectedYear === undefined ? '' : payload.selectedYear,
                selectedGoodsGroup: payload.selectedGoodsGroup,
                selectedStates: payload.selectedStates,
                selectedCities: payload.selectedCities,
                selectedGoods: payload.selectedGoods
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getMonthlyInYearData(context, payload) {
            let response = await axios.post(`/get_sale_report_monthly_year`, {
                selectedCompany: payload.selectedCompany,
                selectedUsers: payload.selectedUsers,
                selectedYear: payload.selectedYear === undefined ? '' : payload.selectedYear,
                selectedGoodsGroup: payload.selectedGoodsGroup,
                selectedStates: payload.selectedStates,
                selectedCities: payload.selectedCities,
                selectedGoods: payload.selectedGoods,
                dayOfMonth: payload.DayOfMonth
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getYearlyFilterData() {
            let response = await axios.get('/get_yearly_report_data')
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getRFM() {
            let response = await axios.get('/get_customer_rfm')
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getTargetDefinitionData() {
            let response = await axios.get('/get_target_data')
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getTargetAuditReport(context, payload) {
            let response = await axios.get(`/sale_target_audit/${payload}`)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },

        async getArchiveTargetsList() {
            let response = await axios.get(`/sale_target_archive`)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },

        async readSMS() {
            let response = await axios.get(`/read_sms_log`)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getNotify() {
            let response = await axios.get('/get_notify')
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getListOfFinancialClaims() {
            let response = await axios.get(`/get_list_of_financial_claims`)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getListOfFinancialClaimsGoods(context, payload) {
            let response = await axios.post(`/get_list_of_financial_claims_goods`, payload)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getListOfFinancialClaimsGoodsByGroupId(context, payload) {
            let response = await axios.post(`/get_list_of_financial_claims_goods_by_group_id`, payload)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async set_customer_pay_visited(context, payload) {
            let response = await axios.get(`/set_customer_pay_visited/${payload}`)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUserReports(context, payload) {
            let response = await axios.post(`/get_by_user_report`, payload)
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default dashboard;
